import { storeClient } from 'apis/apiClients';

// 식단표 카테고리 조회
export const getMealPlanCategories = async () => {
  const { data } = await storeClient.get(`/cafeteria/v1/meal-plan/categories`);
  return data;
};

// 식단표 조회 (카테고리별)
export const getMealPlanListPerCategory = async (serveDate: string) => {
  const { data } = await storeClient.get(`/cafeteria/v1/meal-plan`, { params: { serveDate } });
  return data;
};

// 식단표 등록
export const saveMealPlan = async (params: unknown) => {
  const { data } = await storeClient.post(`/cafeteria/v1/meal-plan`, params);
  return data;
};

// 식단표 bulk 등록
export const saveMealPlanBulk = async (params: unknown) => {
  const { data } = await storeClient.post(`/cafeteria/v1/meal-plan/bulk`, params);
  return data;
};

// 식단표 상세 조회
export const getMealPlanDetail = async (mealPlanIdx: string) => {
  const { data } = await storeClient.get(`/cafeteria/v1/meal-plan/${mealPlanIdx}`);
  return data;
};

// 식단표 수정
export const updateMealPlan = async (mealPlanIdx: string, params: unknown) => {
  const { data } = await storeClient.put(`/cafeteria/v1/meal-plan/${mealPlanIdx}`, params);
  return data;
};

// 식단표 비활성화
export const deleteMealPlan = async (mealPlanIdx: string) => {
  const { data } = await storeClient.delete(`/cafeteria/v1/meal-plan/${mealPlanIdx}`);
  return data;
};

// 식단표 이미지 업로드
export const saveMealPlanImage = async (mealPlanIdx: number, params: unknown) => {
  const { data } = await storeClient.post(`/cafeteria/v1/meal-plan/${mealPlanIdx}/image`, params);
  return data;
};

// 식단표 식단 항목 비활성화
export const deleteMealPlanItems = async (mealPlanItemIdx: number) => {
  const { data } = await storeClient.delete(`/cafeteria/v1/meal-plan/items/${mealPlanItemIdx}`);
  return data;
};

// 식단표 순서 변경
export const updateMealPlanSort = async (mealPlanIdx: number, params: unknown) => {
  const { data } = await storeClient.put(`/cafeteria/v1/meal-plan/${mealPlanIdx}/sort`, params);
  return data;
};

// 식단표 설문조사 통계
export const getMealPlanSurveyStats = async (params: { startDate: string; endDate: string }) => {
  const { data } = await storeClient.get(`/cafeteria/v1/meal-plan/survey-stats`, { params });
  return data;
};
